import XEUtils from 'xe-utils'

import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import httpManager from '../../util/common'
Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: {
  },
  data: () => {

    return {
      indicator1:{
        'Inspection':'审验',
        'Assurance':'鉴证',
        'OtherExamination':'其他验证',
        'UnqualifiedOpinion':'\u6807\u51c6\u65e0\u4fdd\u7559\u610f\u89c1',
        'UnqualifiedOpinionWithExplanatoryParagraph':'\u5e26\u5f3a\u8c03\u4e8b\u9879\u6bb5\u7684\u65e0\u4fdd\u7559\u610f\u89c1',
        'QualifiedOpinion':'\u4fdd\u7559\u610f\u89c1',
        'DisclaimerOpinion':'\u65e0\u6cd5\u8868\u793a\u610f\u89c1',
        'AdverseOpinion':'\u5426\u5b9a\u610f\u89c1',
      },
      data: null,
      tableColumn: [],
      tablePage: {
        pageSize: 10
      },
      loading: false,
    }
  },
  methods: {
    setAllTreeExpand()
{
    this.$refs.xTree.setAllTreeExpand(true)
},
    formatterDate ({ cellValue }, format) {
    return XEUtils.toDateString(cellValue, format || 'yyyy-MM-dd HH:mm:ss')
  },
    trans_data(data){
      for(let i in data){
        let item = data[i]
        for(let key in item){
          if (this.$i18n.locale === 'zh') {
            if (typeof item[key] == 'boolean') {
              item[key] = item[key] ? '是' : '否'
            }
          }
          if(typeof item[key] == 'number' & item[key]>1000){
            item[key] = XEUtils.commafy(item[key], { digits: 2 })
          }
          if (this.$i18n.locale === 'zh') {
            if (item[key] in this.indicator1) {
              item[key] = this.indicator1[item[key]]
            }
          }
        }
      }
      return data
    },
    getESGData() {
      let condition = this.condition
      let self = this
      self.loading = true
      self.tableColumn = []
      self.data = []
      if(!condition){
        return
      }
      httpManager("esg_entity_indicators", null, {condition:condition})
        .then(response => {
          self.data = XEUtils.toArrayTree(self.trans_data(response.data.data))
          self.tableColumn.push.apply(self.tableColumn, response.data.columns)
          self.loading = false
          // self.setAllTreeExpand()
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },

  },
  mounted() {
    // this.condition['oaid'] = null
    this.getESGData()
  },
  computed:mapGetters('esg',{
    condition: 'condition'
  }),
  watch: {
        condition:function(){
            this.getESGData()
        },
        data:function(){
            this.setAllTreeExpand()
        }
    }
}
Vue.component("esg-rating-indication-table", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_rating_indication_table.js